/**
 * Created by mqamhieh on 3/23/17.
 */
(function (angular) {

    "use strict";

    angular
        .module('harriApp')
        .controller('CalculatorController', ['$rootScope', '$scope', '$stateParams', '$filter', 'hUser', '$modal', 'hEvent', '$state', 'appLayoutViewService',
            function ($rootScope, $scope, $stateParams, $filter, hUser, $modal, hEvent, $state, appLayoutViewService) {

            $scope.isSending = false;
            $scope.requestSent = false;

            $rootScope.$on('user_updated', function (event) {
                $scope.isLoggedIn = hUser.isLoggedIn();
                $scope.isEmployer = hUser.isEmployer();
            });

            $scope.pageVersion = 'US';
            $scope.isMobile = $(window).width() < 768;

            Utils.cookieBlockHandler();

            $(document).on("scroll.header2018", function () {
                if ($(this).scrollTop() > 70) {
                    $(".header2018").addClass("fixed");
                } else {
                    $(".header2018").removeClass("fixed");
                }
            });

            $scope.getLogoLink = function () {
                return !hUser.isTopLevelContext() ? '/' : $state.href('appLayout.harriSH.access-portal.main');
            };

            $scope.scheduleDemo = function (source) {
                var data = "";
                var analyticsData = $.extend({
                    label: source,
                    category:"salesRequest"
                }, data);

                hEvent.track('demo_request', analyticsData);

                var modalData = function () {
                    return {
                        source: source,
                        pageVersion: $scope.pageVersion,
                        isMobile: $scope.isMobile,
                        type: 'demo_request'
                    };
                };
                ngLandingPagesUtils.handleRequestDemoClick(modalData);
            };

            $scope.requestPricing = function (source) {
                var data = "";
                var analyticsData = $.extend({
                    label: source,
                    category:"salesRequest"
                }, data);

                hEvent.track('contact_sales', analyticsData);

                var modalData =  function () {
                    return {
                        source: source,
                        pageVersion: $scope.pageVersion,
                        isMobile: $scope.isMobile,
                        type: 'contact_sales'
                    };
                };
                $modal(getRequestDemo2020Modal(modalData));
            };

            $scope.inputs = {
                properties: 25,
                employees: 2000,
                categories: {
                    manager: {
                        employees: 80,
                        turnover_rate: 20,
                        rate_of_pay: 70000,
                        supervisor_rate: 35,
                        office_staff_pay_rate: 35,
                        constants: {
                            screen_hours: 1.7,
                            interview_hours: 1,
                            job_training_hours: 30,
                            unproductive_hours: 80
                        }
                    },
                    assistant: {
                        employees: 120,
                        turnover_rate: 20,
                        rate_of_pay: 55000,
                        supervisor_rate: 30,
                        office_staff_pay_rate: 35,
                        constants: {
                            screen_hours: 1.7,
                            interview_hours: 1,
                            job_training_hours: 30,
                            unproductive_hours: 100
                        }
                    },
                    foe: {
                        employees: 900,
                        turnover_rate: 100,
                        rate_of_pay: 8.00,
                        supervisor_rate: 22.5,
                        office_staff_pay_rate: 35,
                        constants: {
                            screen_hours: 3,
                            interview_hours: 2,
                            job_training_hours: 40,
                            unproductive_hours: 180
                        }
                    },
                    boe: {
                        employees: 900,
                        turnover_rate: 100,
                        rate_of_pay: 13.00,
                        supervisor_rate: 22.5,
                        office_staff_pay_rate: 35,
                        constants: {
                            screen_hours: 3,
                            interview_hours: 2,
                            job_training_hours: 40,
                            unproductive_hours: 180
                        }
                    }
                }
            };
            var watchHeader= true;
            var watchPartials= true;

            var fieldChanged = function (newVal, isChangeInHeaderFields) {
                $scope.allCosts = {
                    'total_turnover_30': 0
                };


                $scope.inputs.categories.assistant.supervisor_rate =  $scope.inputs.categories.manager.rate_of_pay/2000;
                $scope.inputs.categories.boe.supervisor_rate =  $scope.inputs.categories.assistant.rate_of_pay/2000;
                $scope.inputs.categories.foe.supervisor_rate =  $scope.inputs.categories.assistant.rate_of_pay/2000;

                if (isChangeInHeaderFields) {
                    var totalEmployees = parseInt(newVal.employees);
                    $scope.inputs.categories.manager.employees = Math.ceil (totalEmployees * .04)
                    totalEmployees -= $scope.inputs.categories.manager.employees
                    $scope.inputs.categories.assistant.employees = Math.floor (totalEmployees * .0625)
                    totalEmployees -= $scope.inputs.categories.assistant.employees
                    $scope.inputs.categories.foe.employees = Math.floor (totalEmployees * .5)
                    totalEmployees -= $scope.inputs.categories.foe.employees
                    $scope.inputs.categories.boe.employees = Math.ceil (totalEmployees);
                }
                else {
                    watchHeader = false;
                    $scope.inputs.employees =
                        parseInt($scope.inputs.categories.manager.employees) +
                        parseInt($scope.inputs.categories.assistant.employees) +
                        parseInt($scope.inputs.categories.foe.employees) +
                        parseInt($scope.inputs.categories.boe.employees);
                }
                for (var i in $scope.inputs.categories) {
                    var category = $scope.inputs.categories[i];

                    var costs = {
                        'training': category['constants']['job_training_hours'] * category['supervisor_rate'],
                        'unproductive': category['constants']['unproductive_hours'] * ( (i == 'manager' || i == 'assistant') ? category['rate_of_pay']/2000 : category['rate_of_pay']),
                        'hiring': 0
                    };

                    if (i == 'manager') {
                        costs['hiring'] += 0.5 * category['supervisor_rate']; // Post a job
                        costs['hiring'] += 0.5 * category['rate_of_pay'] / 2000; // Acquiring from Socialx
                        costs['hiring'] += 0.25 * category['rate_of_pay'] / 2000; // Sharing candidates
                        costs['hiring'] += category['constants']['screen_hours'] * category['office_staff_pay_rate']; // Screening Applicants
                        costs['hiring'] += category['constants']['interview_hours'] * category['supervisor_rate']; // Coordinating Interviews
                        costs['hiring'] += 3.5 * category['supervisor_rate']; // Executing interviews
                        costs['hiring'] += 0.5 * category['office_staff_pay_rate']; // Send offers
                        costs['hiring'] += 0.25 * category['office_staff_pay_rate']; // Manage Offers
                        costs['hiring'] += 1.5 * category['office_staff_pay_rate']; // Onboarding Documents
                        costs['hiring'] += 0.5 * category['office_staff_pay_rate']; // Payroll Setup
                        costs['hiring'] += 1 * category['office_staff_pay_rate']; // Reference Checking
                        costs['hiring'] += 1 * category['office_staff_pay_rate']; // Drug testing
                    }

                    costs['hardCosts30'] = costs['training'] + costs['unproductive'] + costs['hiring'];
                    costs['totalHardCosts30'] = costs['hardCosts30'] * category['employees'] * (category['turnover_rate'] / 100);
                    $scope.allCosts['total_turnover_30'] += costs['totalHardCosts30'];
                }

                $scope.allCosts['total_turnover_90'] = $scope.allCosts['total_turnover_30'] * 2;
                $scope.allCosts['total_turnover_avg'] = Math.round($scope.allCosts['total_turnover_30'] * 0.3 + $scope.allCosts['total_turnover_90'] * 0.6);
                $scope.allCosts['harri_saving_30'] = Math.round($scope.allCosts['total_turnover_30'] - (
                        (299 * $scope['inputs']['properties'] * 12) +
                        95.42 +
                        ($scope.allCosts['total_turnover_30'] * (1 - 10/100))
                    ));

                $scope.allCosts['harri_saving_90'] = $scope.allCosts['harri_saving_30'] * 2;

                $scope.allCosts['harri_saving_avg'] = Math.round($scope.allCosts['harri_saving_30'] * 0.3 + $scope.allCosts['harri_saving_90'] * 0.6);
                $scope.allCosts['harri_saving_avg'] = ($scope.allCosts['harri_saving_avg'] > 0) ? $scope.allCosts['harri_saving_avg'] : 0;
            }
            $scope.$watchCollection("inputs", function (newVal, oldVal) {
                if (watchHeader) {
                    fieldChanged(newVal, true);
                } else {
                    watchHeader = true;
                }
            });

            $scope.$watchCollection("inputs.categories.manager", function (newVal, oldVal) {
                if ((newVal.turnover_rate != oldVal.turnover_rate) || (newVal.rate_of_pay != oldVal.rate_of_pay) ||  $scope.inputs.employees !=
                        $scope.inputs.categories.manager.employees +
                        $scope.inputs.categories.assistant.employees +
                        $scope.inputs.categories.foe.employees +
                        $scope.inputs.categories.boe.employees) {
                    fieldChanged(newVal, false);
                }
            });

            $scope.$watchCollection("inputs.categories.foe", function (newVal, oldVal) {
                if ((newVal.turnover_rate != oldVal.turnover_rate) || (newVal.rate_of_pay != oldVal.rate_of_pay) || $scope.inputs.employees !=
                    $scope.inputs.categories.manager.employees +
                    $scope.inputs.categories.assistant.employees +
                    $scope.inputs.categories.foe.employees +
                    $scope.inputs.categories.boe.employees) {
                    fieldChanged(newVal, false);
                }
            });

            $scope.$watchCollection("inputs.categories.boe", function (newVal, oldVal) {
                if ((newVal.turnover_rate != oldVal.turnover_rate) || (newVal.rate_of_pay != oldVal.rate_of_pay) || $scope.inputs.employees !=
                    $scope.inputs.categories.manager.employees +
                    $scope.inputs.categories.assistant.employees +
                    $scope.inputs.categories.foe.employees +
                    $scope.inputs.categories.boe.employees) {
                    fieldChanged(newVal, false);
                }

            });

            $scope.$watchCollection("inputs.categories.assistant", function (newVal, oldVal) {
                if ((newVal.turnover_rate != oldVal.turnover_rate) || (newVal.rate_of_pay != oldVal.rate_of_pay) || $scope.inputs.employees !=
                    $scope.inputs.categories.manager.employees +
                    $scope.inputs.categories.assistant.employees +
                    $scope.inputs.categories.foe.employees +
                    $scope.inputs.categories.boe.employees) {
                    fieldChanged(newVal, false);
                }
            });

            $scope.isSideBarExpanded = function () {
                return appLayoutViewService.isSideBarExpanded();
            };

            $scope.getToggleSource = function () {
                return appLayoutViewService.getToggleSource();
            };

            hUser.init()
                .then(function () {
                    appLayoutViewService.updateBrandTheme();
                });

        }]);

})(angular);
